export default __webpack_public_path__ + "static/media/facebook_icon.fce0d217.svg";